import { render, staticRenderFns } from "@/modules/Newcase/templates/case-new-dashboard.html?vue&type=template&id=96fb07d6&scoped=true&"
import script from "@/modules/Newcase/scripts/case-new-dashboard.ts?vue&type=script&lang=js&"
export * from "@/modules/Newcase/scripts/case-new-dashboard.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Newcase/styles/case-new-dashboard.scss?vue&type=style&index=0&id=96fb07d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fb07d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
